import { object, string } from 'yup';
import i18n from '../../../i18n';

// Types
import { Accident } from '../../../types/accident';

export const createAccidentSchema = () => object<Accident>({
  mediumKnowledge: string().required(() => i18n.t('validation:required')),
  laneCutting: string().required(() => i18n.t('validation:required')),
  policeReport: string().required(() => i18n.t('validation:required')),
  surveillanceBody: string().when(
    '$isAReportState',
    ([isAReportState], schema) =>
      isAReportState
        ? schema.required(() => i18n.t('validation:required'))
        : schema.notRequired()
  ),
  policeReportNumber: string().when(
    ['$isAReportState'],
    ([isAReportState], schema) =>
      isAReportState
        ? schema.required(() => i18n.t('validation:required'))
        : schema.notRequired()
  ),
  weather: string().required(() => i18n.t('validation:required')),
  surfaceCondition: string().required(() => i18n.t('validation:required')),
  luminosity: string().required(() => i18n.t('validation:required')),
  conditionsDriving: string().required(() => i18n.t('validation:required')),
  roadConditionDescription: string().required(() =>
    i18n.t('validation:required')
  ),
  images: string().required(() => i18n.t('validation:image.required')),
  noticeRoadTeamDate: string().required(() => i18n.t('validation:required')),
  arrivalRoadTeamDate: string().required(() => i18n.t('validation:required')),
  departureRoadTeamDate: string().required(() => i18n.t('validation:required')),
});

// Backward compat
export const AccidentSchema = createAccidentSchema();
